import React from 'react'
import PropTypes from 'prop-types'

export interface PlaceholderIconProps {
  id: string | number // prefer string, but number is provided for backwards compatibility
  name: string
}

function colorCssClass (id: string | number): string {
  const idStr = id.toString()
  const numericSupplierId = parseInt(idStr, 10)
  // If id was non-numeric, use the length of the string to achieve a bit of deterministic randomness
  const validNumericSupplierId = isNaN(numericSupplierId) ? idStr.length : numericSupplierId
  const cssClasses = ['', 'green', 'orange']
  const index = validNumericSupplierId % cssClasses.length
  return cssClasses[index]
}

export default function PlaceholderIcon ({ id, name }: PlaceholderIconProps): React.ReactElement {
  const colorClass = colorCssClass(id)
  const missingIconName = name.length > 0 ? name.trim()[0].toUpperCase() : '?'

  return (
    <div className={`placeholder-icon ${colorClass}`} role='img' aria-label={`Logo for supplier ${name}`}>
      {missingIconName}
    </div>
  )
}

PlaceholderIcon.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string.isRequired
}
